import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CheckboxWrapper,
  LabelSpan,
  Wrapper
} from "components/common/Checkbox/Checkbox.style";
import React, { ReactNode, useMemo } from "react";

export interface IProps {
  checked?: boolean;
  white?: boolean;
  label: ReactNode | string;
  onClick: () => void;
  labelFontSize?: string;
}

function Checkbox({ checked, white, label, onClick, labelFontSize }: IProps) {
  return useMemo(
    () => (
      <Wrapper
        onClick={onClick}
        white={white}
        className="checkboxAndLabelWrapper"
        labelFontSize={labelFontSize}
      >
        <CheckboxWrapper
          checked={checked}
          white={white}
          className="checkboxWrapper"
          labelFontSize={labelFontSize}
        >
          {checked ? (
            <FontAwesomeIcon
              icon="check"
              size="2x"
              style={{
                color: "white",
                width: "36px",
                height: "36px",
                marginTop: "2px"
              }}
            />
          ) : null}
        </CheckboxWrapper>
        <LabelSpan className="labelSpan">{label}</LabelSpan>
      </Wrapper>
    ),
    [checked]
  );
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/Checkbox.tsx